module.exports = __webpack_public_path__ + "img/item-dashboard.75302846.svg";